import { render } from "./TheHeaderProfile.vue?vue&type=template&id=5853a099&scoped=true"
import script from "./TheHeaderProfile.vue?vue&type=script&lang=ts"
export * from "./TheHeaderProfile.vue?vue&type=script&lang=ts"

import "./TheHeaderProfile.vue?vue&type=style&index=0&id=5853a099&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5853a099"

export default script